import { createFileRoute } from '@tanstack/react-router'
import { CustomerRoutingDidsPage } from '@/features/customer/pages/routing-dids'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/customer/routing-dids')({
  component: CustomerRoutingDidsPage,
  beforeLoad: requireRole(['customer']),
})

